export default __webpack_public_path__ + "static/media/product_suite.a1beffd2.png";